import { okAsync, ResultAsync } from 'neverthrow'
import { createRecordBatch, deleteFile } from '../api'
import {
  FailedToCreateFileRecordError,
  FailedToDeleteFileError,
  FailedToDeleteFolderError,
} from '../errors'

export const deleteFileResultAsync = (fileId: string, userId: string) =>
  ResultAsync.fromPromise(
    deleteFile(fileId, userId),
    () => new FailedToDeleteFileError(fileId)
  )

export const deleteFolderResultAsync = (fileId: string, userId: string) =>
  ResultAsync.fromPromise(
    deleteFile(fileId, userId),
    () => new FailedToDeleteFolderError(fileId)
  )

export const deleteFilesResultAsync = <
  T extends { fileId: string; userId: string }
>(
  files: Readonly<T[]>
) =>
  ResultAsync.combine(
    files.map((f) => deleteFileResultAsync(f.fileId, f.userId))
  ).andThen((results) => okAsync(results.map((result) => result.data.data)))

export const deleteFoldersResultAsync = <
  T extends { fileId: string; userId: string }
>(
  folders: Readonly<T[]>
) =>
  ResultAsync.combine(
    folders.map((f) => deleteFolderResultAsync(f.fileId, f.userId))
  ).andThen((results) => okAsync(results.map((result) => result.data.data)))

export const createFileRecordBatchResultAsync = (
  payload: {
    parentFolderId: string | null
    fileName: string
    dir: string
    contentType: string
  }[]
) =>
  ResultAsync.fromPromise(
    createRecordBatch(payload),
    () => new FailedToCreateFileRecordError()
  )
